import React from 'react';
import './HeroSection.scss';

const HeroSection = () => {
  return (
    <div className="hero-section1">
      <div className="total-revenue">
        <h2>Total Revenue</h2>
        <p>$10,000</p>
      </div>
    </div>
  );
};

export default HeroSection;

